(function () {
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle("frame-modal-open", !!lock);
  }

  // -------- TOP OFFSET (announcement + header) --------
  function getTopOffset() {
    // On somme tous les éléments FIXED/STICKY qui sont collés en haut
    const els = Array.from(document.querySelectorAll("body *"));
    const bars = [];

    for (const el of els) {
      if (!el || !el.getBoundingClientRect) continue;

      const cs = getComputedStyle(el);
      if (cs.position !== "fixed" && cs.position !== "sticky") continue;

      const r = el.getBoundingClientRect();
      if (r.height <= 0) continue;

      // Doit être réellement dans la pile du haut
      if (r.top > 2) continue; // pas collé au top
      if (r.bottom <= 0) continue; // pas visible

      // On évite de compter des trucs énormes (genre overlay)
      if (r.height > 250) continue;

      bars.push({ top: Math.round(r.top), height: Math.round(r.height) });
    }

    // Dé-dupe par (top,height)
    const uniq = new Map();
    for (const b of bars) {
      uniq.set(`${b.top}_${b.height}`, b);
    }

    const list = Array.from(uniq.values()).sort((a, b) => a.top - b.top);

    let sum = 0;
    for (const b of list) sum += Math.max(0, b.height);

    return sum;
  }

  // -------- PORTAL (move modal to <body>) --------
  function portalToBody(modal) {
    if (!modal) return;

    if (!modal.__portal) {
      modal.__portal = {
        parent: modal.parentNode,
        next: modal.nextSibling,
      };
    }
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function restorePortal(modal) {
    if (!modal || !modal.__portal) return;
    const { parent, next } = modal.__portal;
    if (!parent) return;

    if (next && next.parentNode === parent) parent.insertBefore(modal, next);
    else parent.appendChild(modal);
  }

  function applyModalInlineLayout(modal) {
    const top = getTopOffset();

    // Modal overlay
    modal.style.position = "fixed";
    modal.style.left = "0";
    modal.style.right = "0";
    modal.style.bottom = "0";
    modal.style.top = "0";
    modal.style.zIndex = "2147483647";

    const backdrop = modal.querySelector(".frame-modal__backdrop");
    const panel = modal.querySelector(".frame-modal__panel");

    if (backdrop) {
      backdrop.style.position = "fixed";
      backdrop.style.left = "0";
      backdrop.style.right = "0";
      backdrop.style.bottom = "0";
      backdrop.style.top = top + "px";
      backdrop.style.height = "calc(100vh - " + top + "px)";
      backdrop.style.zIndex = "0";
    }

    if (panel) {
      panel.style.position = "fixed";
      panel.style.right = "0";
      panel.style.bottom = "0";
      panel.style.top = top + "px";
      panel.style.height = "calc(100vh - " + top + "px)";
      panel.style.zIndex = "1";
    }
  }

  // -------- Generic modal helpers --------
  function openModal(modal, trigger) {
    if (!modal) return;

    // ✅ IMPORTANT : on sort la modale du DOM “local”
    portalToBody(modal);

    // ✅ IMPORTANT : on force la mise en page en inline (impossible à override)
    applyModalInlineLayout(modal);

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    lockScroll(true);
  }

  function closeModal(modal, trigger) {
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    lockScroll(false);

    // ✅ on remet la modale à son endroit d’origine (propre)
    restorePortal(modal);
  }

  function dispatchNativeChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // -------- Frame --------
  function setFrameNativeValue(picker, value) {
    const select = picker.querySelector("[data-frame-native]");
    if (!select) return;
    select.value = value;
    dispatchNativeChange(select);
  }

  // ✅ FIX: URL d’asset fiable (via data-assets-base injecté en Liquid)
 function resolveAssetUrl(picker, assetFile) {
  if (!assetFile) return "";

  // 1) ✅ best: base fournie par le Liquid (stable)
  const base = picker.getAttribute("data-assets-base") || "";
  if (base) {
    return base + assetFile;
  }

  // 2) fallback: essayer de déduire depuis une image existante dans le picker
  const anyImg = picker.querySelector("img[src*='/assets/']");
  if (anyImg) {
    const src = anyImg.getAttribute("src") || "";
    const j = src.indexOf("/assets/");
    if (j !== -1) return src.slice(0, j + "/assets/".length) + assetFile;
  }

  // 3) last resort: ne rien renvoyer (plutôt que /t/0 qui casse)
  return "";
}


  // ✅ FIX: update thumb sans carré gris (onerror -> fallback)
  function updateFrameTriggerUI(picker, displayName, assetFile) {
    const title = picker.querySelector(".frame-trigger__title");
    const thumb = picker.querySelector("[data-frame-trigger-thumb]");
    if (title) title.textContent = displayName || "";

    if (!thumb) return;

    thumb.innerHTML = "";

    if (!assetFile) {
      thumb.innerHTML = '<span class="frame-trigger__empty" aria-hidden="true"></span>';
      return;
    }

    const url = resolveAssetUrl(picker, assetFile);
    if (!url) {
      thumb.innerHTML = '<span class="frame-trigger__empty" aria-hidden="true"></span>';
      return;
    }

    const img = document.createElement("img");
    img.loading = "lazy";
    img.alt = displayName || "";
    img.src = url;

    img.onerror = function () {
      thumb.innerHTML = '<span class="frame-trigger__empty" aria-hidden="true"></span>';
    };

    thumb.appendChild(img);
  }

  // -------- Size --------
  function setSizeNativeValue(picker, value) {
    const select = picker.querySelector("[data-size-native]");
    if (!select) return;
    select.value = value;
    dispatchNativeChange(select);
  }

  function updateSizeTriggerUI(picker, value) {
    const title =
      picker.querySelector("[data-size-trigger-title]") ||
      picker.querySelector(".frame-trigger__title");
    if (title) title.textContent = value || "";
  }

  // -------- Delegated events --------
  document.addEventListener("click", function (e) {
    // FRAME open
    const frameTrigger = closest(e.target, "[data-frame-trigger]");
    if (frameTrigger) {
      const picker = closest(frameTrigger, "[data-frame-picker]");
      if (!picker) return;
      const modal = picker.querySelector("[data-frame-modal]");
      openModal(modal, frameTrigger);
      return;
    }

    // FRAME close
    const frameClose = closest(e.target, "[data-frame-close]");
    if (frameClose) {
      const modal = closest(frameClose, ".frame-modal");
      const picker = modal
        ? modal.__portal?.parent && closest(modal.__portal.parent, "[data-frame-picker]")
        : null;

      // fallback classique si on n'arrive pas à remonter
      const picker2 = picker || closest(frameClose, "[data-frame-picker]");

      const trigger = picker2 ? picker2.querySelector("[data-frame-trigger]") : null;
      closeModal(modal, trigger);
      return;
    }

    // FRAME option
    const frameOption = closest(e.target, "[data-frame-option]");
    if (frameOption) {
      // la modale est dans <body>, donc le picker est dans __portal.parent
      const modal = closest(frameOption, ".frame-modal");
      const picker =
        modal && modal.__portal && modal.__portal.parent
          ? closest(modal.__portal.parent, "[data-frame-picker]")
          : closest(frameOption, "[data-frame-picker]");

      if (!picker) return;

      const value = frameOption.getAttribute("data-frame-value");
      const display = frameOption.getAttribute("data-frame-display") || value;
      const asset = frameOption.getAttribute("data-frame-asset") || "";

      // active state (dans la modale portaled)
      modal.querySelectorAll("[data-frame-option]").forEach((btn) => btn.classList.remove("is-active"));
      frameOption.classList.add("is-active");

      setFrameNativeValue(picker, value);
      updateFrameTriggerUI(picker, display, asset);

      const trigger = picker.querySelector("[data-frame-trigger]");
      closeModal(modal, trigger);
      return;
    }

    // SIZE open
    const sizeTrigger = closest(e.target, "[data-size-trigger]");
    if (sizeTrigger) {
      const picker = closest(sizeTrigger, "[data-size-picker]");
      if (!picker) return;
      const modal = picker.querySelector("[data-size-modal]");
      openModal(modal, sizeTrigger);
      return;
    }

    // SIZE close
    const sizeClose = closest(e.target, "[data-size-close]");
    if (sizeClose) {
      const modal = closest(sizeClose, ".frame-modal");
      const picker =
        modal && modal.__portal && modal.__portal.parent
          ? closest(modal.__portal.parent, "[data-size-picker]")
          : closest(sizeClose, "[data-size-picker]");

      const trigger = picker ? picker.querySelector("[data-size-trigger]") : null;
      closeModal(modal, trigger);
      return;
    }

    // SIZE option
    const sizeOption = closest(e.target, "[data-size-option]");
    if (sizeOption) {
      const modal = closest(sizeOption, ".frame-modal");
      const picker =
        modal && modal.__portal && modal.__portal.parent
          ? closest(modal.__portal.parent, "[data-size-picker]")
          : closest(sizeOption, "[data-size-picker]");

      if (!picker) return;

      const value = sizeOption.getAttribute("data-size-value");

      modal.querySelectorAll("[data-size-option]").forEach((btn) => btn.classList.remove("is-active"));
      sizeOption.classList.add("is-active");

      setSizeNativeValue(picker, value);
      updateSizeTriggerUI(picker, value);

      const trigger = picker.querySelector("[data-size-trigger]");
      closeModal(modal, trigger);
      return;
    }
  });

  // ESC close
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const open = document.querySelector(".frame-modal.is-open");
    if (!open) return;
    closeModal(open, null);
  });

  // Resync triggers when native select changes elsewhere
  document.addEventListener("change", function (e) {
    const frameSelect = closest(e.target, "[data-frame-native]");
    if (frameSelect) {
      const picker = closest(frameSelect, "[data-frame-picker]");
      if (!picker) return;

      const value = frameSelect.value;
      const btn = picker.querySelector(
        '[data-frame-option][data-frame-value="' + CSS.escape(value) + '"]'
      );
      if (btn) {
        const display = btn.getAttribute("data-frame-display") || value;
        const asset = btn.getAttribute("data-frame-asset") || "";
        updateFrameTriggerUI(picker, display, asset);
      }
      return;
    }

    const sizeSelect = closest(e.target, "[data-size-native]");
    if (sizeSelect) {
      const picker = closest(sizeSelect, "[data-size-picker]");
      if (!picker) return;
      updateSizeTriggerUI(picker, sizeSelect.value);
    }
  });

  // Si ton header change de taille au scroll, on recalcule pendant l’ouverture
  window.addEventListener(
    "scroll",
    function () {
      const open = document.querySelector(".frame-modal.is-open");
      if (open) applyModalInlineLayout(open);
    },
    { passive: true }
  );

  window.addEventListener("resize", function () {
    const open = document.querySelector(".frame-modal.is-open");
    if (open) applyModalInlineLayout(open);
  });
})();
